<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <HelpMenu></HelpMenu>
            <TermofUseSection></TermofUseSection>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import HelpMenu from "./HelpMenu.vue";
import TermofUseSection from "./TermofUseSection.vue";
import MainBalance from "./MainBalance.vue";

export default {
  name: "TermsOfUse",
  components: {
    "app-header": AppHeader,
    HelpMenu: HelpMenu,
    TermofUseSection: TermofUseSection,
    MainBalance: MainBalance,
  },
};
</script>

<style lang="scss" scoped>
</style>
